import { render, staticRenderFns } from "./mobile-perfil-component.vue?vue&type=template&id=4e5c9fb9&scoped=true&"
import script from "./mobile-perfil-component.vue?vue&type=script&lang=ts&"
export * from "./mobile-perfil-component.vue?vue&type=script&lang=ts&"
import style0 from "./mobile-perfil-component.vue?vue&type=style&index=0&id=4e5c9fb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5c9fb9",
  null
  
)

export default component.exports